import { apiClient, handleResp } from './utils'

export default {
  getSpeakers() {
    return handleResp(apiClient().get('/care_speaker_bios'))
  }
}
